import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { LoaderBtn, LoaderBtnDelete } from '@modules/loading/Loader';

export default function Button({
  form = null,
  type = 'button',
  variant = 'primary',
  height = 'h-10',
  width = null,
  startIcon = null,
  endIcon = null,
  font = 'text-sm',
  to = null,
  handler = null,
  isLoading = false,
  disabled = false,
  children,
}) {
  const variants = {
    primary:
      'cursor-pointer flex flex-row items-center justify-center gap-1 px-4 rounded-md bg-primary text-white border-[1px] border-primary',
    secondary:
      'cursor-pointer flex flex-row items-center justify-center gap-1 px-4 rounded-md transition-all bg-white dark:bg-blackFont-800 text-primary dark:text-white border-[1px] border-primary dark:border-blackFont-700 hover:bg-primary hover:text-white dark:hover:bg-blackFont-700',
    error:
      'cursor-pointer flex flex-row items-center justify-center gap-1 px-4 rounded-md bg-error text-white border-[1px] border-error',
    text: 'cursor-pointer flex flex-row items-center justify-center gap-1 px-4 rounded-md bg-white text-text-hard border-[1px] border-text-hard',
    textNormal:
      'cursor-pointer flex flex-row items-center justify-center gap-1 px-4 rounded-md bg-white text-text-normal border-[1.5px] border-text-normal',
    deactive:
      'cursor-pointer flex flex-row items-center justify-center gap-1 px-4 rounded-md text-text-hard dark:text-white border-[1px] border-[#EBEBEB] dark:border-blackFont-700 bg-[#EBEBEB] dark:bg-blackFont-800',
  };

  const icons = {
    plus: (
      <svg className="w-[18px] h-[18px]">
        <use href="#plus"></use>
      </svg>
    ),
    trash: (
      <svg className="w-6 h-6">
        <use href="#trash"></use>
      </svg>
    ),
    avatar: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.301 18.9281L18.9215 18.5607C20.2077 17.799 21 16.3914 21 14.8681V9.13192C21 7.6086 20.2077 6.20099 18.9215 5.43932L14.0785 2.57125C12.7923 1.80958 11.2077 1.80958 9.92154 2.57125L5.07846 5.43932C3.7923 6.20099 3 7.6086 3 9.13192V14.8681C3 16.3914 3.7923 17.799 5.07846 18.5607L5.69896 18.9281M18.301 18.9281L14.0785 21.4288C12.7923 22.1904 11.2077 22.1904 9.92154 21.4288L5.69896 18.9281M18.301 18.9281C17.0431 16.6982 14.6924 15.1979 12 15.1979C9.30762 15.1979 6.95686 16.6982 5.69896 18.9281"
          stroke="white"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <circle
          cx="3"
          cy="3"
          r="3"
          transform="matrix(1 0 0 -1 9 12)"
          stroke="white"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
    ),
    gallery: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M22 14L19.061 11.8839C17.5338 10.7843 15.4467 10.898 14.0479 12.1569L9.95209 15.8431C8.55331 17.102 6.4662 17.2157 4.93901 16.1161L2 14M6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2H6C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22ZM11 8.5C11 9.88071 9.88071 11 8.5 11C7.11929 11 6 9.88071 6 8.5C6 7.11929 7.11929 6 8.5 6C9.88071 6 11 7.11929 11 8.5Z"
          stroke="#616161"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    ),
  };

  const fonts = {
    sm: 'text-sm max-sm:text-xs',
    base: 'text-base max-sm:text-sm',
  };

  const content = (
    <>
      {startIcon && icons[startIcon]}
      <span>{children}</span>
      {endIcon && icons[endIcon]}
    </>
  );

  return (
    <>
      {to ? (
        <Link
          to={to}
          className={clsx(variants[variant], fonts[font], width ? width : 'w-fit', height ? height : 'h-10')}
        >
          {content}
        </Link>
      ) : (
        <button
          form={form}
          type={type}
          disabled={isLoading || disabled}
          onClick={handler}
          className={clsx(
            variants[variant],
            fonts[font],
            width ? width : 'w-fit',
            height ? height : 'h-10',
            disabled &&
              'disabled:bg-light-grey disabled:text-text-normal disabled:border-light-grey disabled:cursor-not-allowed',
          )}
        >
          {isLoading && variant == 'error' ? <LoaderBtnDelete /> : isLoading ? <LoaderBtn /> : content}
        </button>
      )}
    </>
  );
}
